import { useStyles } from "./styles";
import { IdName } from "@/main/models/common";
import { StatusQuoteSupplierItem } from "@/main/services/enum/StatusQuoteSupplierItem";
interface IStatusProps {
	status: IdName;
}

export function renderColorQuoteSupplierItemStatus(id: number) {
	switch (id) {
		case StatusQuoteSupplierItem.Pending:
			return "#fab01c";
		case StatusQuoteSupplierItem.Answered:
			return "#06d032";
		default:
			return "#ff0000";
	}
}

export default function QuoteSupplierItemStatusComponent({ status }: IStatusProps) {
	const classes = useStyles();

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={status.name}
			style={{
				backgroundColor: renderColorQuoteSupplierItemStatus(status.id),
			}}
		>
			<span className={classes.spanContainer}>{status.name}</span>
		</div>
	);
}
